import { useValidate } from "formvalidation/hooks";
import React from "react";
import { Input } from "semantic-ui-react";
import { useSemanticUiInputRef } from "utilities/hookutils";

interface Props {
  value: string
  onChange: (newCode: string) => void
  validationKey: string
}

const alphaNumericRegex = /^[A-Za-z0-9]+$/;

const BookkeepingInput = (props: Props) => {
  const validateBookkeepingCode = (newCode: string): string | boolean => {
    const doesntHaveThreeCharacters = newCode.length !== 3;
    if (doesntHaveThreeCharacters) {
      return false
    }

    const hasInvalidChars = (alphaNumericRegex.exec(newCode)) == null;
    if (hasInvalidChars) {
      return false
    }

    return true;
  };

  const semanticRef = useSemanticUiInputRef();

  const validation = useValidate({
    key: props.validationKey,
    title: "Bookkeeping code",
    value: props.value,
    validate: async () => validateBookkeepingCode(props.value),
    ref: semanticRef.ref,
  })

  return <Input
    ref={semanticRef.refSetter}
    value={props.value?.toUpperCase()}
    onChange={(_, { value }) => { props.onChange(value?.toUpperCase()); }}
    error={validation.error.hasError}
    maxLength={3}
  />;
};

export default BookkeepingInput;